import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/bases/[slug]/BaseDetailPage.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["AdsterraBanner"] */ "/vercel/path0/src/components/adsterra/AdsterraAds.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/base/BaseArticle/BaseArticleInlineAd.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/base/BaseArticle/BaseArticleResponsive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/base/BaseArticle/BaseDesktopRightRailAd.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/base/BaseArticle/BaseDetailResponsiveAds.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/base/BaseArticle/BaseMobileAdSensePlacement.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/base/BaseArticle/BaseMobileVisitAwareAd.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/base/BaseArticle/BasePostCtaMobileAd.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/base/BaseArticle/BaseSimpleDisplayAd.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/base/BaseArticle/BaseTabletDesktopBannerAd.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/base/BaseArticle/BaseTabletMidBannerAd.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/base/BaseCard/BaseCardClient.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/base/BaseGrid/BaseGrid.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/base/BaseCard/BaseCard.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/base/BaseCreatorProof/BaseCreatorProof.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/base/BaseEventProof/BaseEventProof.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/base/BaseContextMeta/BaseContextMeta.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/base/BaseGrid/BaseGridClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/base/BaseGrid/RelatedBasesIsland/RelatedBasesIslandClient.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/base/BaseHero/BaseHero.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/base/BaseArticle/BaseArticle.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/base/BaseImageSwitcher/BaseImageSwitcher.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/base/BaseInfoBar/BaseInfoBar.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/base/BaseRating/BaseRating.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/base/BaseGrid/FeaturedCategorySection/FeaturedCategorySection.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/base/BaseGrid/FeaturedStrengthSection/FeaturedStrengthSection.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/base/BaseRating/BaseRatingInteractive.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/base/BaseStrengthLinks/BaseStrengthLinks.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/base/BaseViewTracker/BaseViewTracker.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/base/CategoryFilters/CategoryFiltersMenuButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/base/CategoryFilters/FilterableBaseGrid.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/base/SeoBlock/SeoBlock.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/base/ClanCastleTroops/ClanCastleTroops.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/base/CategoryFilters/CategoryFilters.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/navigation/AdAwareLink/AdAwareLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/nitro/NitroMobileBaseAd.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ui/StarRating/StarRating.module.css");
